import { actionTypes } from '../types'

const initState = {
    url: '',
};

const waiverReducer = (state = initState, action) => {

    switch (action.type) {

        case actionTypes.WAIVER_SIGN:
            {
                let newState;
                newState = {
                    url: action.payload.resp
                }
                return newState;
            }

        default:
            {
                return state
            }

    }

}

export default waiverReducer
